/* (c) Copyright Frontify Ltd., all rights reserved. */

import { createFondueIcon } from '../createFondueIcon';

/**
 * @component @name ArrowTopRight
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0xOC40NzggMTUuNzhhLjc1Ljc1IDAgMDEtMS41IDBWOC4wOUw2Ljk5IDE4LjA3OWEuNzUuNzUgMCAwMS0xLjA2MS0xLjA2bDkuOTg3LTkuOTg4aC03LjY5YS43NS43NSAwIDAxMC0xLjVoMTAuMjV6Ii8+PC9zdmc+) - https://fondue-components.frontify.com/?path=/story/icons_icons--default&args=iconName:arrow-top-right
 * @see https://fondue-components.frontify.com/?path=/story/icons_icons--default - Documentation
 */
export const IconArrowTopRight = createFondueIcon('ArrowTopRight', [["path",{"fill":"currentColor","d":"M18.478 15.78a.75.75 0 01-1.5 0V8.09L6.99 18.079a.75.75 0 01-1.061-1.06l9.987-9.988h-7.69a.75.75 0 010-1.5h10.25z"}]]);
